<template>
  <!-- TODO: 监控敏感词 -->
  <!-- TODO: 监控首响超时 -->
  <!-- TODO: 监控响应超时 -->
  <div class="app">
    <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 100%;">
      <el-tab-pane label="机器人对话监控" name="robot" style="height: 100%;">
        <bd-thread-robot></bd-thread-robot>
      </el-tab-pane>
      <el-tab-pane label="人工对话监控" name="thread" style="height: 100%;">
        <bd-thread-agent></bd-thread-agent>
      </el-tab-pane>
      <!--  v-if="showAuthority.debug" -->
      <el-tab-pane label="客服监控" name="agent" style="height: 100%;">
        <bd-table-agent></bd-table-agent>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BdThreadAgent from '@/components/dashboard/main/monitor/BdThreadAgent'
import BdTableAgent from '@/components/dashboard/main/monitor/BdTableAgent'
import BdThreadRobot from '@/components/dashboard/main/monitor/BdThreadRobot'

export default {
  name: 'bd-monitor',
  components: { BdThreadAgent, BdTableAgent, BdThreadRobot },
  data () {
    return {
      activeName: 'robot',
      show: false,
    }
  },
  computed: {
    ...mapGetters([ 'showAuthority' ]),
  },
  methods: {
    handleClick (tab, event) {
      // console.log(tab, event)
    }
  }
}
</script>

<style scope>
.el-tabs__header {
  margin: 0px !important;
  background-color: #f2f2f2 !important;
}
.el-tabs__content {
  padding-top: 0px !important;
}
</style>
